<template>
  <transition name="next">
    <div class="select-worried">
      
      <h2 class="select-worried__title">気になるテーマを選んでください。<br />いくつでもOK</h2>
      <panel-list
        :list="worried.items"
        :select="select"
        @change="value => $emit('change', value)"
      />
      <submit-button
        @click="$emit('next')"
      />
    </div>
  </transition>
</template>

<script>
import PanelList from "./PanelList"
import SubmitButton from "../partials/SubmitButton"

export default {
  name: "SelectWorried",
  components: {
    PanelList,
    SubmitButton
  },
  props: {
    worried: {
      type: Object,
      default () {
        return {}
      }
    },
    select: {
      type: Array,
      default () {
        return []
      }
    }
  },
}</script>

<style scoped lang="scss">
@import '../../../../sass/commons/commonVariables.scss';

.select-worried {
  &__title {
    margin-bottom: 35px;
    font-weight: bold;
    font-size: 16px;
    line-height: 1.5;
    color: $col_temp_gray4;
    text-align: center;

    @include mq('w320'){
      font-size: 20px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// ../../../../resources/assets/js/utvStore/components/Subscription/SelectWorried.vue